import React, { memo } from 'react';

import PropTypes from 'prop-types';

import { defaultSize, sizePropsTypes } from './icons.constants';

const Triangle = ({ size = defaultSize, color = '#F79009' }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 11 10"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M3.77899 0.989217C4.54782 -0.329741 6.45218 -0.329738 7.221 0.989219L10.7256 7.00148C11.5004 8.3307 10.5423 10 9.00458 10H1.99542C0.457688 10 -0.500407 8.3307 0.27441 7.00147L3.77899 0.989217Z"
      fill={color}
    />
  </svg>
);

Triangle.propTypes = {
  ...sizePropsTypes,
  color: PropTypes.string,
};

export default memo(Triangle);
